import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "heroicons-react";
import { Accordion, Image, Navbar } from "react-bootstrap";
import logo from "../../../logo.svg";
import "./SideBar.css";
import AdminSideBar from "./AdminSideBar";
import EcomSideBar from "./EcomSideBar";
import ManagerSideBar from "./ManagerSideBar";
import SupervisorSideBar from "./SupervisorSideBar";
import AccountSideBar from "./AccountSideBar";
import PosSideBar from "./PosSideBar";
import { signInUser } from "../../Utility/Auth";

const SideBar = () => {
  const user = signInUser();

  return (
    <>
      {(user?.type === "admin" || user?.type === "owner") && <AdminSideBar />}
      {user.type === "ecom" && <EcomSideBar />}
      {user.type === "manager" && <ManagerSideBar />}
      {user.type === "supervisor" && <SupervisorSideBar />}
      {user.type === "accounts" && <AccountSideBar />}
      {user.type === "POS" && <PosSideBar />}
    </>
  );
};

export default SideBar;
